import { DurabilitySFDR } from '../../../../types';
export var list = [
    DurabilitySFDR.YES,
    DurabilitySFDR.NO,
];
